
































import {
  defineComponent,
  ref,
  onMounted,
  computed,
} from '@vue/composition-api';
import { PeriodResponse } from '@oare/types';
import PeriodYear from './PeriodYear.vue';
import sl from '@/serviceLocator';

export default defineComponent({
  name: 'PeriodsView',
  components: { PeriodYear },

  setup() {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const loading = ref(false);
    const periods = ref<PeriodResponse>({ years: [] });
    const filterSwitch = ref(false);

    onMounted(async () => {
      try {
        loading.value = true;
        periods.value = await server.getPeriods();
      } catch (err) {
        actions.showErrorSnackbar('Error retrieving periods', err as Error);
      } finally {
        loading.value = false;
      }
    });

    const getPeriods = computed(() => {
      if (!filterSwitch.value && periods.value.years) {
        const filteredPeriods: PeriodResponse = {
          years: periods.value.years.filter(
            year =>
              year.occurrences > 0 ||
              year.months.some(month => month.occurrences > 0) ||
              year.months.some(month =>
                month.weeks.some(week => week.occurrences > 0)
              )
          ),
        };
        return filteredPeriods;
      } else {
        return periods.value;
      }
    });

    function filterPeriods(value: boolean) {
      filterSwitch.value = value;
    }

    return {
      periods,
      loading,
      filterSwitch,
      getPeriods,
      filterPeriods,
    };
  },
});
